import '../scss/main.scss';
import '../utils/hello';
import '../components/sliderSwiper';
import { filter } from '../components/filter';
import { TopBar } from '../components/topBar';
import '../components/quantityInput';
import '../components/quantity-select';
import '../services/submit-newsletter-form';
import '../utils/hide-language-switcher';
import '../components/infiniteScroll';
import '../components/backInStock';

import { Cart, openCloseCart } from '../components/cart';
import { Header } from '../components/header';
import { Collection } from '../components/collection';
import { HeroHome } from '../components/heroHome';
import { Reviews } from '../components/reviews';
import { SliderSection } from '../components/sliderSection';
import { PhotographerOtherProfiles } from '../components/photographerOtherProfiles';
import { PhotographerGallery } from '../components/photographerGallery';
import { PhotographerKit } from '../components/photographerKit';
import { Newsletter } from '../components/newsletter';
import { Archive } from '../components/archive';
import { ContactUs } from '../components/contactUsRedirect';
import '../components/predictiveSearch';
import '../components/ourDistributors';
import { reloadPage } from '../components/reloadPageBackArrow';
import { deleteButtonStyles } from '../components/backStockButton';
import { Section360 } from '../components/360';
import { Discounts } from '../components/discountCode';
import { History } from '../components/pageHistory';
import { selectTabs } from '../components/menu-tabs';

selectTabs('.first-level', '.second-level')
reloadPage();
filter();
const collection = new Collection();
collection.infiniteScroll();
const pageHistory = new History();
new TopBar('#js-topbar-component', '#js-topbar-close');
new Header();
new HeroHome();
new ContactUs('#header');
new Reviews();
new SliderSection();
new PhotographerOtherProfiles();
new PhotographerGallery();
new PhotographerKit();
new Newsletter();
new Discounts('.add-cart-form', '.cart-items__form', '.list-products');
const cart = new Cart();
window.Cart = cart;
cart.addToCart();
new Archive();
new Section360();
deleteButtonStyles();
openCloseCart();
